/**
 * Concept Archetype
 * 
 * @Version 1.0
 * @Author Daniel Lepe
 */

import _ from 'lodash'
import { store } from "@/store/store-init"


const label = '#';

const baseController = 'devoluciones'

const baseIndex = baseController + '/index'

let getDevItemCaptions = () => {
    let devItemCaptions = [
        { key: 'titulo_extendido', label: 'Producto' },
        { key: 'cantidad', label: 'Movimiento' },
        { key: 'cantidad_devuelta', label: 'Ingreso efectivo' },
        { key: 'costo', label: 'Costo' },
        { key: 'precio', label: 'Precio' },
    ],
    restHiddenCaptions = ['costo'];
    let items2return = null;
    if (_.isPlainObject(store.getters.authGetUser)) {
        switch (store.getters.authGetUser.tipoUsuario) {
            case 'Admin':
                items2return = devItemCaptions;
                break;
            default:
                items2return = _.filter(_.cloneDeep(devItemCaptions), item => {
                    return (restHiddenCaptions.indexOf(item.key) == -1)
                });
                break;
        }
    }
    console.debug(items2return);
    return items2return;
}

const archetype = [
    // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id',
        label,
        readonly: true
    },
    {
        key: 'devolucion_detalles',
        type: 'hidden',
        default: []
    },
    {
        key: 'origen',
        // type: 'hidden',
        readonly: true
    },
    [
        {
            key: 'created',
            readonly: true
        },
        {
            key: 'modified',
            readonly: true
        }
    ],
    [
        {
            key: 'estatus',
            readonly: true
        },
    ],
    [
        {
            key: 'fechayhora_cierre',
            label: 'Fecha de cierre',
            readonly: true
        }

    ]
];

const captions = [
    { key: 'id', label },
    { key: 'titulo_preparacion', label: 'Preparación' },
    // { key: 'creador' },
    { key: 'revision', label: 'Revisión' },
    // { key: 'origen' },
    { key: 'created', label: 'Fecha de creación' },
    // { key: 'fechayhora_cierre', label: 'Cierre' },
    { key: 'estatus' },
    { key: '_' },
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

const estatusFilterSample = {
    key: 'estatus',
    required: true,
    options: [
        {label: 'Pendientes', key: 'En curso'},
        // 'Pendiente',
        {label: 'Terminados', key: 'Finalizada'}
    ]
};

const origenFilterSample = {
    key: 'origen',
    required: true,
    options: [
        {key: 'Preparación de alimento', label: 'Cocina'},
        {key: 'Devolucion cocina', label: 'Devoluciones'},
        {key: 'all', label: 'Todos'},
        // 'Restaurant'
    ],
    default: 'all',
};

const quicktableFilters = () => {
    return [
        origenFilterSample,
        estatusFilterSample,
    ]
}


export {
    archetype,
    captions,
    baseIndex,
    getDevItemCaptions,
    automodalHandler,
    quicktableFilters
}